module.exports = __webpack_public_path__ + "static/img/34559309_1400857351863_mthumb.656bd98.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/34559309_1400857351863_mthumb.webp
// module id = Yw9f
// module chunks = 0